import React from 'react';
import FormStarProvider from './FormStarProvider';
import { Form } from 'antd';
import { fetchAddStarProvider } from '../../../../store/StarProviderSlice';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';

const AddStarProviders: React.FC<any> = (props) => {
  const { getList, totalData } = props;
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const handleAddSubmit = (data: any) => {
    dispatch(fetchAddStarProvider(data))
      .then(() => {
        // form.resetFields();
        getList();
      })
      .catch(() => {});
  };  

  return (
    <FormStarProvider
      form={form}
      handleAddSubmit={handleAddSubmit}
      mode={'add'}
      totalData={totalData}
    />
  );
};
export default AddStarProviders;
